import EFLight from '@/components/UI/svg/LandingPage/EFLight';
import gtm from '@/utils/gtm';
import { useGlobal } from '@/utils/useGlobal';
import EcoImg from 'eco-design/base/eco-img';
import EFHairDryer from 'elem/ui-assets/icons/appliances/EFHairDryer';
import EFMicrowave from 'elem/ui-assets/icons/appliances/EFMicrowave';
import EFPhone from 'elem/ui-assets/icons/appliances/EFPhone';
import EFRefrigerator from 'elem/ui-assets/icons/appliances/EFRefrigerator';
import EFTV from 'elem/ui-assets/icons/appliances/EFTV';
import EFWiFi from 'elem/ui-assets/icons/appliances/EFWiFi';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import AnimatedSection from '../../us/StatusA/Components/AnimatedSection';
import styles from './index.module.scss';

interface TabSectionConfig {
    pc: string;
    pad: string;
    h5: string;
    list: {
        title: string;
        desc: React.ReactNode;
        items: {
            devide: number;
            name: string;
            times: string;
            icon: React.ReactNode;
        };
    };
}

export default function TabSection(props: { config?: Partial<TabSectionConfig> }) {
    const { useLang } = useGlobal();
    const { t } = useLang('TabSection');
    const { locale = 'us' } = useRouter();
    const [activeIndex, setActiveIndex] = useState(0);
    const [enter, setEnter] = useState(false);
    const isEU = ['eu', 'de', 'fr', 'it', 'es', 'nl'].includes(locale);

    // const [textEnter, setTextEnter] = useState(false);

    // useScrollAnimation({
    //     triggerSelector: '.page-tabSection .large-screen-container',
    //     onEnter: () => setTextEnter(true),
    // });

    const ElectricBlanket = () => (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3.375" y="9.2002" width="23.625" height="15.75" rx="1.6875" stroke="white" strokeWidth="1.35" />
            <path
                d="M6.75 21.5752V13.7002C6.75 13.0789 7.25368 12.5752 7.875 12.5752H9C9.62132 12.5752 10.125 13.0789 10.125 13.7002V20.4502C10.125 21.0715 10.6287 21.5752 11.25 21.5752H12.375C12.9963 21.5752 13.5 21.0715 13.5 20.4502V13.7002C13.5 13.0789 14.0037 12.5752 14.625 12.5752H15.75C16.3713 12.5752 16.875 13.0789 16.875 13.7002V20.4502C16.875 21.0715 17.3787 21.5752 18 21.5752H19.125C19.7463 21.5752 20.25 21.0715 20.25 20.4502V13.7002C20.25 13.0789 20.7537 12.5752 21.375 12.5752H22.5C23.1213 12.5752 23.625 13.0789 23.625 13.7002V21.5752"
                stroke="white"
                strokeWidth="1.35"
                strokeLinecap="round"
            />
            <path
                d="M7.875 24.2752V27.2002C7.875 27.8215 8.37868 28.3252 9 28.3252H29.8125C30.4338 28.3252 30.9375 27.8215 30.9375 27.2002V18.2002"
                stroke="white"
                strokeWidth="1.35"
            />
            <rect x="28.6875" y="9.7627" width="4.5" height="7.875" rx="0.5625" stroke="white" strokeWidth="1.125" />
            <path
                d="M31.7812 12.2939C31.7812 12.7599 31.4035 13.1377 30.9375 13.1377C30.4715 13.1377 30.0938 12.7599 30.0938 12.2939C30.0938 11.828 30.4715 11.4502 30.9375 11.4502C31.4035 11.4502 31.7812 11.828 31.7812 12.2939Z"
                fill="white"
            />
            <circle cx="30.9375" cy="15.3877" r="0.5625" fill="white" />
        </svg>
    );

    const parseTitle = (title: string) => {
        // 匹配数字和单位
        const numberMatch = title.match(/(\d[\d,. ]*)/);
        if (!numberMatch) return { num: '', prefix: '', suffix: title, isShowNumber: false };

        const numStr = numberMatch[1].trim();
        const isConvert = numStr.includes(',');
        const num = isConvert ? parseFloat(numStr.replace(',', '.').replace(/[^\d.]/g, '')) : parseFloat(numStr.replace(/[^\d.]/g, ''));
        // 分割前缀和后缀
        const [beforeNum, afterNum] = title.split(numStr);

        return {
            num,
            isConvert,
            isShowNumber: true,
            prefix: beforeNum.trim(),
            suffix: ` ${afterNum?.trim()}` || '',
        };
    };

    const isInteger = (value: any) => {
        if (typeof value === 'string') {
            return !value.includes(',');
        }
        if (typeof value !== 'number' || isNaN(value) || !isFinite(value)) {
            return false;
        }
        return Number.isInteger(value);
    };

    // eslint-disable-next-line react/jsx-key
    const IconsArray = [<EFLight />, <EFPhone />, <EFWiFi />, <EFTV />, <EFRefrigerator />, <EFMicrowave />, <ElectricBlanket />, <EFHairDryer />];

    const imgArray = {
        us: [
            {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1757557628635-okmqyu-compressed-%E5%8D%8A%E5%A4%A9.png',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1757557750972-vncnv1-compressed-%E5%8D%8A%E5%A4%A9.png',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1757557649217-iroksu-compressed-1%E5%A4%A9.png',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1757557773681-fb5qi3-compressed-1%E5%A4%A9.png',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1757557723969-fgimge-compressed-%E4%B8%A4%E5%A4%A9.png',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1757557791384-5qdsur-compressed-2%E5%A4%A9.png',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1757557696363-zm6njj-compressed-%E4%B8%89%E5%A4%A9.png',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1757557806447-enu906-compressed-3%E5%A4%A9.png',
            },
        ],
        eu: [
            {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761119287500-7iu4j7-compressed-%E5%8D%8A%E5%A4%A9.png',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761119345511-y3btri-compressed-%E5%8D%8A%E5%A4%A9.png',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761119301836-cvjh8m-compressed-1%E5%A4%A9.png',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761119355677-mknf0e-compressed-2%2B2%E5%BA%A6%E7%94%B5%202.png',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761119314687-e4l5yk-compressed-%E4%B8%A4%E5%A4%A9.png',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761119380636-gssc2q-compressed-2%E5%A4%A9.png',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761119327279-i80slj-compressed-2%2B8%E5%BA%A6%E7%94%B5%201.png',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761119390142-mp1ewy-compressed-3%E5%A4%A9.png',
            },
        ],
        uk: [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1765336442924/6-pc-1.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1765336532555/6-h5-1.png',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1765336442125/6-pc-2.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1765336502434/6-h5-2.png',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1765336441759/6-pc-3.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1765336502709/6-h5-3.png',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1765336441266/6-pc-4.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1765336441933/6-h5-4.png',
            },
        ],
    };
    const imgs = isEU ? imgArray['eu'] : imgArray[locale] || imgArray.us;

    const defaultConfig = {
        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1757494640658-map629-compressed-%E5%8B%BF%E7%A7%BB%E5%8A%A8%EF%BC%8C%E6%98%AF%E4%B8%AA%E7%BB%84%E4%BB%B6%E8%83%8C%E6%99%AF%E5%9B%BE.jpg',
        pad: 'https://websiteoss.ecoflow.com/figma-uploads/1757494669531-vu9cys-compressed-PAD/IPHONE%E6%89%8B%E6%9C%BA%E5%85%B1%E7%94%A8%E8%83%8C%E6%99%AF.jpg',
        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1757494669531-vu9cys-compressed-PAD/IPHONE%E6%89%8B%E6%9C%BA%E5%85%B1%E7%94%A8%E8%83%8C%E6%99%AF.jpg',
        list: new Array(4).fill(null).map((item, index) => {
            return {
                title: t(`tab_title${index + 1}`),
                desc: t.rich(`tab_desc${index + 1}`, {
                    sup: (text: string) => <sup>{text}</sup>,
                }),
                footerDesc: t(`tab_item${index + 1}_footer_desc`),
                items: IconsArray.map((icon, key) => {
                    return {
                        devide: 2,
                        name: t(`tab_item${index + 1}_name${key + 1}`) || t(`tab_item1_name${key + 1}`),
                        times: t(`tab_item${index + 1}_time${key + 1}`),
                        ...parseTitle(t(`tab_item${index + 1}_time${key + 1}`)),
                        icon,
                    };
                }),
                img: imgs[index],
            };
        }),
    };

    const config = { ...defaultConfig, ...props.config };

    const Tabs = (props.config?.list || defaultConfig.list).map((item: any, index: number) => ({
        ...defaultConfig.list[index],
        ...item,
    }));

    const TabItems = Tabs.map((item) => item.title);

    const handleClickTab = (e, tab: string, k: number) => {
        setEnter(false);
        setActiveIndex(k);
        setTimeout(() => {
            setEnter(true);
        }, 50);

        // 埋点传参
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: 'none',
            button_name: tab,
            __btn_id1: `${styles.TabSection} .tab-${k + 1}`,
            __btn_id2: tab,
            __btn_type: 'text',
        });
        if (e.target) {
            const parent = (e.target as HTMLDivElement).parentElement?.parentElement;
            if (parent) {
                const parentRect = parent.getBoundingClientRect();
                const elemRect = (e.target as HTMLDivElement).getBoundingClientRect();

                const padding = window.innerWidth > 1024 ? 0 : window.innerWidth > 768 ? 48 : 16;
                let scrollLeft: number;

                // 如果是第一个item，滚动到最左边
                if (k === 0) {
                    scrollLeft = elemRect.left - parentRect.left - padding;
                }
                // 如果是最后一个item，滚动到最右边
                else if (k === Tabs.length - 1) {
                    scrollLeft = elemRect.right - parentRect.right + padding;
                }
                // 其他情况居中显示
                else {
                    scrollLeft = elemRect.left - parentRect.left - parentRect.width / 2 + elemRect.width / 2;
                }
                parent.scrollBy({
                    left: scrollLeft,
                    behavior: 'smooth',
                });
            }
        }
    };

    useEffect(() => {
        AniContainer.create({
            triggerElement: '.page-tabSection .content-items',
            triggerHook: 1,
            offset: 240,
            onEnter: () => {
                setEnter(true);
            },
            onLeave: () => {
                setEnter(false);
            },
        });
    }, []);

    return (
        <div className={`page-tabSection ${styles.TabSection} GtmModuleData-section`} id="TabSection" data-section-id="d3m-tab-section">
            <div className="img-box">
                <EcoImg className="img-bg" pc={config.pc} pad={config.pad} h5={config.h5} isOpenLazy={true} />
                <div className="product-img-container h5-img">
                    {Tabs.map((tab, idx) => (
                        <EcoImg
                            key={idx}
                            className={`product-img product-img-${activeIndex} ${activeIndex === idx ? 'active' : ''}`}
                            pc={tab.img.pc}
                            pad={tab.img.h5}
                            h5={tab.img.h5}
                            isOpenLazy={true}
                        />
                    ))}
                </div>
            </div>
            <div className="large-screen-container">
                <div className="tab-container">
                    <div className="tab-box">
                        <AnimatedSection variant="fadeInUp" options={{ delay: 200 }}>
                            <div className="tab-content">
                                <div className="content-title">{Tabs[activeIndex].desc}</div>
                                {/* <div className={`content-title ${textEnter ? 'enter' : ''}`}>{Tabs[activeIndex].desc}</div> */}
                                <div className="content-items">
                                    {Tabs[activeIndex].items.map((item, index) => (
                                        <div key={index} className="item">
                                            <div className="item-icon">{item.icon}</div>
                                            <div className="item-info">
                                                <div className="item-name">{item.name}</div>
                                                <div className={`item-times item-ani ${enter ? 'enter' : ''}`}>
                                                    {item.isShowNumber && (
                                                        <div className={`ani-box ani-container ani-${activeIndex}-${index}`}>
                                                            {Array.from({ length: item.devide }, (_, i) => {
                                                                const numStr = item.num.toString();
                                                                const decimalLength = !isInteger(item.num) && numStr.slice(numStr.indexOf('.') + 1).length;
                                                                const value =
                                                                    i === item.devide.length - 1
                                                                        ? item.num
                                                                        : isInteger(item.num)
                                                                        ? parseInt((i + 1) * (item.num / item.devide))
                                                                        : ((i + 1) * (item.num / item.devide)).toFixed(decimalLength);

                                                                return (
                                                                    <p className="num" key={i}>
                                                                        {item.isConvert ? value.replace('.', ',') : value}
                                                                    </p>
                                                                );
                                                            })}
                                                        </div>
                                                    )}
                                                    {/* {item.times} */}
                                                    <div className="suffix">{item?.suffix}</div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </AnimatedSection>
                    </div>
                </div>

                <div className="product-img-container pc-img">
                    {Tabs.map((tab, idx) => (
                        <EcoImg
                            key={idx}
                            className={`product-img product-img-${activeIndex} ${activeIndex === idx ? 'active' : ''}`}
                            pc={tab.img.pc}
                            pad={tab.img.h5}
                            h5={tab.img.h5}
                            isOpenLazy={true}
                        />
                    ))}
                </div>
            </div>
            <div className="eco-content">
                <div className="tabs-box">
                    <ul className="tabs">
                        {TabItems?.map((tab: string, k: number) => (
                            <li
                                className={`GtmModuleData-btn-text tab-${k + 1} tab${activeIndex === k ? ' active' : ''}`}
                                key={tab}
                                onClick={(e) => handleClickTab(e, tab, k)}
                                data-btn-id={`tabsection_tab-${k + 1}`}
                            >
                                {tab}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="footer-desc-wrapper">
                <div className="footer-desc">{Tabs[activeIndex].footerDesc}</div>
            </div>
        </div>
    );
}
